import classnames from 'classnames';
import { isStringAJsonObject } from 'helpers/string.helper';
import React from 'react';
import { ReactComponent as AutoInsuranceIcon } from 'style/_assets/icons/marketplace/art-autoinsurance.svg';
import { ReactComponent as AutoLoansIcon } from 'style/_assets/icons/marketplace/art-auto-loans.svg';
import { ReactComponent as BusinessLoansIcon } from 'style/_assets/icons/marketplace/art-business.svg';
import { ReactComponent as CelebrateIcon } from 'style/_assets/icons/marketplace/art-celebrate.svg';
import { ReactComponent as ChevronRight } from 'style/_assets/icons/chevron-right.svg';
import { ReactComponent as CreditCardIcon } from 'style/_assets/icons/marketplace/art-credit-card.svg';
import { ReactComponent as CreditReport } from 'style/_assets/icons/viewCreditReport.svg';
import { ReactComponent as HomeInsuranceIcon } from 'style/_assets/icons/marketplace/art-homeinsurance.svg';
import { ReactComponent as HomeLoansIcon } from 'style/_assets/icons/marketplace/art-homelender.svg';
import { ReactComponent as LifeInsuranceIcon } from 'style/_assets/icons/marketplace/art-lifeinsurance.svg';
import { ReactComponent as MedicalIcon } from 'style/_assets/icons/marketplace/art-medical.svg';
import { ReactComponent as NewHomeIcon } from 'style/_assets/icons/marketplace/art-newhome.svg';
import { ReactComponent as PersonalLoansIcon } from 'style/_assets/icons/marketplace/art-personal-loans.svg';
import { ReactComponent as PoolIcon } from 'style/_assets/icons/marketplace/art-pool.svg';
import { ReactComponent as ScoreImpact } from 'style/_assets/icons/score-impact.svg';
import { ReactComponent as TravelIcon } from 'style/_assets/icons/marketplace/art-travel.svg';
import { Image } from 'components/Image/Image';
import { isObject } from 'helpers/objectHelpers';
import './PIcon.scss';

const iconMapping = {
  right_pointing_arrow_icon: {
    iconSvg: ChevronRight,
  },
  view_credit_report_icon: {
    iconSvg: CreditReport,
  },
  impacting_score_icon: {
    iconSvg: ScoreImpact,
  },
  life_insurance_icon: {
    iconSvg: LifeInsuranceIcon,
  },
  home_insurance_icon: {
    iconSvg: HomeInsuranceIcon,
  },
  auto_loan_icon: {
    iconSvg: AutoLoansIcon,
  },
  home_loan_icon: {
    iconSvg: HomeLoansIcon,
  },
  auto_insurance_icon: {
    iconSvg: AutoInsuranceIcon,
  },
  credit_card_icon: {
    iconSvg: CreditCardIcon,
  },
  personal_loan_icon: {
    iconSvg: PersonalLoansIcon,
  },
  business_loan_icon: {
    iconSvg: BusinessLoansIcon,
  },
  celebrate_icon: {
    iconSvg: CelebrateIcon,
  },
  medical_icon: {
    iconSvg: MedicalIcon,
  },
  new_home_icon: {
    iconSvg: NewHomeIcon,
  },
  pool_icon: {
    iconSvg: PoolIcon,
  },
  travel_icon: {
    iconSvg: TravelIcon,
  },
  web_booster_hero: {
    imgClass: 'webBoosterPromo',
  },
  builderIconEnrollDebitCard: {
    imgClass: 'builderIconEnrollDebitCard',
  },
  builderIconManualPaymentDue: {
    imgClass: 'builderIconManualPaymentDue',
  },
  builderIconCompletedCycle: {
    imgClass: 'builderIconCompletedCycle',
  },
  builderDelinquentPayment: {
    imgClass: 'builderDelinquentPayment',
  },
  builderIconNoBalanceIncurred: {
    imgClass: 'builderIconNoBalanceIncurred',
  },
};

const PIcon = props => {
  const configuredProps = {
    className: props.className,
    style: props.style,
  };
  const selectedIcon = iconMapping[props.icon];
  const isIconAnObject = isStringAJsonObject(props.icon);

  if (selectedIcon?.iconSvg) {
    const Icon = selectedIcon.iconSvg;
    return <Icon {...configuredProps} />;
  } else if (selectedIcon?.imgClass) {
    return (
      <Image
        imgClass={classnames(selectedIcon.imgClass, props.className)}
        style={props.style}
      />
    );
  } else if (isObject(props.icon) || isIconAnObject) {
    let config = props.icon;
    if (isIconAnObject) {
      config = JSON.parse(props.icon);
    }
    const {
      width,
      height,
      widthMobile,
      heightMobile,
      widthDesktop,
      heightDesktop,
      src,
      srcMobile,
      srcDesktop,
      alt,
      className,
    } = config;
    return (
      <>
        <img
          className={classnames(props.className, className, 'd-hide')}
          style={{
            width: widthMobile ?? width,
            height: heightMobile ?? height,
          }}
          src={srcMobile ?? src}
          alt={alt}
        />
        <img
          className={classnames(props.className, className, 't-hide')}
          style={{
            width: widthDesktop ?? width,
            height: heightDesktop ?? height,
          }}
          src={srcDesktop ?? src}
          alt={alt}
        />
      </>
    );
  } else if (typeof props.icon === 'string' && /http[s]:/.test(props.icon)) {
    return (
      <img className={props.className} src={props.icon} alt={props.icon} />
    );
  } else if (typeof props.icon === 'string') {
    return <Image imgClass={classnames(props.icon, props.className)} />;
  } else {
    return ' ';
  }
};

export default PIcon;
